import { createContext } from 'react'
import type { StoreApi } from 'zustand'

import type { AnalysisStore } from '@/modules/analysis'
import type { ChatStore } from '@/modules/chat'
import type { InsightsStore, ProjectStore } from '../stores'

export interface ProjectStores {
  projectStore: StoreApi<ProjectStore>
  projectAnalysisStore: StoreApi<AnalysisStore>
  insightsStore: StoreApi<InsightsStore>
  chatStore: StoreApi<ChatStore>
}

export const ProjectContext = createContext<ProjectStores | null>(null)
